import { useEffect, useState } from 'react';
import NotificationsModal from './NotificationsModal';
import { NOTIFY, getNotifyLevel } from './notifications';

export default function SubscribeButton() {
  const [open, setOpen] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    setSubscribed((await getNotifyLevel()) === NOTIFY.DAILY);
    setLoaded(true);
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => loaded && setOpen(true)}
        disabled={!loaded}
        className={
          'flex items-center gap-2 rounded-full border border-blue-500/60 bg-blue-500/10 px-4 py-2 text-sm font-medium text-blue-300 transition hover:bg-blue-500/20 ' +
          (loaded ? '' : 'cursor-default')
        }
      >
        {!loaded ?
          <span className="flex items-center gap-2" aria-hidden="true">
            <span className="h-4 w-4 animate-pulse rounded-full bg-blue-400/30" />
            <span className="h-3 w-24 animate-pulse rounded bg-blue-400/30" />
          </span>
        : <>
            {subscribed ?
              <svg
                className="h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
              </svg>
            : <svg
                className="h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M4 4h16v16H4z" />
                <path d="m22 6-10 7L2 6" />
              </svg>
            }
            {subscribed ? 'Manage notifications' : 'Subscribe'}
          </>
        }
      </button>

      {open && (
        <NotificationsModal
          autoSubscribe={!subscribed}
          onClose={() => {
            setOpen(false);
            refresh();
          }}
        />
      )}
    </>
  );
}
